import { render, staticRenderFns } from "./ClientSearch_Search.vue?vue&type=template&id=36b06774&"
import script from "./ClientSearch_Search.vue?vue&type=script&lang=js&"
export * from "./ClientSearch_Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports